import { ApolloClient } from 'apollo-client'
import { BatchHttpLink } from 'apollo-link-batch-http'
import { createUploadLink } from 'apollo-upload-client'
import { setContext } from 'apollo-link-context'
import { AUTH_TOKEN } from '../constants'
import { InMemoryCache } from 'apollo-cache-inmemory'

const apiUrl = process.env.API_URL || process.env.REACT_APP_API_URL;

const httpLink = new BatchHttpLink({uri: apiUrl})
const cache = new InMemoryCache({
  addTypename: false
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(AUTH_TOKEN)
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      userAgent: 'GHD',
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const uploadLink = createUploadLink({
  uri: `${apiUrl}/graphql`
})

const defaultOptions = {
  query: {
    fetchPolicy: 'network-only',
  },
  mutate: {
    errorPolicy: 'network-only'
  }
}

export const client = new ApolloClient({
  link: authLink.concat(uploadLink, httpLink),
  cache,
  defaultOptions
})



// WEBPACK FOOTER //
// ./src/apollo/ApolloClient.js